'use client';

import InlineTextLink from '@/components/inlineTextLink/InlineTextLink';
import { RichText } from '@/components/richText/RichText';
import { useSettings } from '@/providers/SettingsProvider';
import type { GlobalServiceErrorStoryblok } from '@/types/component-types-sb';

import classes from './ServiceError.module.scss';

const ServiceError: React.FC<{ blok: GlobalServiceErrorStoryblok }> = ({ blok }) => {
  const settings = useSettings();

  return (
    <div className={classes.serviceErrorModal}>
      {blok.headline && <h2>{blok.headline}</h2>}
      {blok.text && <RichText className={classes.textContent} text={blok.text} />}
      {!!blok.show_phone && settings && (
        <InlineTextLink
          data-testid="server-error-link"
          link={settings.service_phone_tel_link}
          className={classes.phone}
        >
          {settings.service_phone_formatted}
        </InlineTextLink>
      )}
    </div>
  );
};

export default ServiceError;
